<template>
  <div>
    <el-form ref="form" :model="form" class="form_flex">
      <el-row>
        <el-col :span="6">
          <el-form-item
            label="用户ID"
            :label-width="formLabelWidth"
            prop="userId"
          >
            <el-input
              class="search-input"
              v-model="form.name"
              placeholder="请输入用户ID"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="微信昵称"
            :label-width="formLabelWidth"
            prop="userId"
          >
            <el-input
              class="search-input"
              v-model="form.name"
              placeholder="请输入微信昵称"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            label="openID"
            :label-width="formLabelWidth"
            prop="userId"
          >
            <el-input
              class="search-input"
              v-model="form.name"
              placeholder="请输入openID"
              @blur="onBlur"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item class="btn">
            <el-button @click="onSearch" icon="el-icon-search" size="small"
              >查询</el-button
            >
            <el-button
              size="small"
              icon="el-icon-delete"
              @click="resetForm('form')"
              >清空</el-button
            >
            <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
              >刷新</el-button
            >
            <PermissionsBtn2
              :icon="'el-icon-download'"
              :btnType="'primary'"
              :permissionName="'_Export'"
              :downloadUrl="'/userAdmin/Report/introduceDownLoad'"
              :form="exportForm"
              :checkList="checkList"
            ></PermissionsBtn2>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import { getAreaListApi } from '@/api/areaApi.js';
import { houseList } from '@/api/houseApi.js';
import { mapGetters } from 'vuex';
import { getUserModelApi } from '@/api/user.js';
import { getToken } from '@/utils/token.js';
import PermissionsBtn2 from '@/components/PermissionsBtn2';
import { dateFormate } from '@/utils/dateFormate';
import { decrypt } from '@/utils/encryp';
export default {
  name: 'recommendedReports',
  inject: ['reload'], // 注入reload方法
  props: {
    checkList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    PermissionsBtn2,
  },
  data() {
    return {
      formLabelWidth: '120px', // 对话框中 文本的尺寸
      statisticsTime: [],
      loading: false,
      form: {
        startTime: '', //统计开始时间
        endTime: '', //统计结束时间
        areaId: '',
        userId: '',
        houseId: '',
        isExport: false,
      },
      exportForm: {
        areaId: '',
        startTime: '', //统计开始时间
        endTime: '', //统计结束时间
        userId: '',
        houseId: '',
        pageSize: 20,
        pageIndex: 1,
        isExport: true,
      },
      options: [],
      houseData: [],
      props: {
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          const userInfo = JSON.parse(getToken('userInfo'));
          let { areaId, roleType } = userInfo;
          if (level == 0) {
            getAreaListApi({ areaId, roleType }).then((res) => {
              if (res.code === 200) {
                const arr = res.data.area.map((item) => {
                  return {
                    value: item.areaId,
                    label: item.areaName,
                    leaf: true,
                  };
                });
                this.options = arr;
                resolve(arr);
              }
            });
          }
        },
      },
      defaultDateTime: [],
    };
  },
  computed: {
    ...mapGetters(['pickerOptions']),
  },
  watch: {},
  created() {
    this.getHouseList();
  },
  mounted() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
    this.statisticsTime = [start, end];
    console.log('timeFormate', dateFormate(start));
    let startTime = dateFormate(start);
    let endTime = dateFormate(end);
    this.defaultDateTime = [startTime, endTime];

    this.exportForm['startTime'] = startTime;
    this.exportForm['endTime'] = endTime;
  },
  methods: {
    // 获取楼盘列表
    getHouseList() {
      try {
        houseList({
          areaId: this.form.areaId || '',
          name: '',
          isExport: true,
        }).then((res) => {
          this.houseData = JSON.parse(
            JSON.stringify(res.data.dataList)
              .replace(/houseName/g, 'label')
              .replace(/houseId/g, 'value')
          );
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    handleChangeValue(arr) {
      this.form.areaId = arr[0];
      this.exportForm['areaId'] = this.form['areaId'];
      this.getHouseList();
    },

    // 修改时间
    hanldeChangeTime(val) {
      if (!val) {
        this.exportForm['startTime'] = '';
        this.exportForm['endTime'] = '';
        return;
      }
      this.exportForm['startTime'] = val[0];
      this.exportForm['endTime'] = val[1];
    },

    // 搜索邀请人
    async searchUser(val) {
      this.loading = true;
      let res = await getUserModelApi({
        userName: val,
        areaId: this.areaId,
        pageIndex: 1,
        pageSize: 100000,
      });
      this.loading = false;
      this.options = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 选择下拉选择邀请人
    checkItem(val) {
      this.form.userId = val;
      this.exportForm.userId = val;
    },

    // 下拉选择楼盘
    handleChangeHouse(val) {
      this.exportForm.houseId = val;
    },

    // 搜索，触发父组件请求数据的方法
    onSearch() {
      // 统计时间
      this.form['startTime'] = this.statisticsTime
        ? dateFormate(this.statisticsTime[0])
        : '';
      this.form['endTime'] = this.statisticsTime
        ? dateFormate(this.statisticsTime[1])
        : '';

      this.$emit('search', this.form);
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 清空表单
    resetForm(formName) {
      this.exportForm['areaId'] = '';
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-input {
  margin: 0 10px;
  width: 260px;
}

.select {
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
<style lang="less">
.invite-report {
  .el-table .total-row {
    background: beige;
  }
}
</style>
